/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    var nav,
        touchEnabled,
        activeMenu,
        timer,
        MENU_TIMEOUT = 300,
        openMenu = function openMenu(ev) {
        var item = ev.currentTarget,
            subMenu = item.getElementsByTagName("div")[0];
        item.classList.add("hover");
        closeMenu();
        activeMenu = subMenu;
    },
        closeMenu = function closeMenu(ev) {
        var item = ev ? ev.currentTarget : activeMenu ? activeMenu.parentNode : undefined;
        if (item) {
            item.classList.remove("hover");
        }
        activeMenu = null;
    };
    try {
        touchEnabled = 'createTouch' in document || window.navigator.msPointerEnabled;
        if (touchEnabled) {
            nav = document.querySelectorAll(".site-nav > ul > li");
            if (window.navigator.msPointerEnabled) {
                Array.prototype.forEach.call(nav, function (item) {
                    item.addEventListener("MSPointerOver", openMenu, false);
                    item.addEventListener("MSPointerOut", closeMenu, false);
                    document.body.addEventListener("MSPointerOver", closeMenu, false);
                });
            } else {
                Array.prototype.forEach.call(nav, function (item) {
                    item.addEventListener("touchstart", openMenu, false);
                    item.addEventListener("touchend", closeMenu, false);
                    document.body.addEventListener("touchstart", closeMenu, false);
                });
            }
        }
    } catch (e) {
        if (console) {
            console.error(e);
        }
    }
})();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (window.jQuery) {
    (function ($, sitenav) {
        "use strict";

        sitenav = sitenav || (window.sitenav = {});
        sitenav.App = sitenav.App || (sitenav.App = {});

        sitenav.App.ReturnUrlBuilder = {
            appendReturnUrl: function appendReturnUrl() {
                var currentUrl = location.href;

                $(".append-return-url").each(function (idx, data) {
                    var href = $(data).attr("href");

                    var signOutLink = $(data).data("signout");
                    var shouldAppend = !(signOutLink && href.indexOf(location.host) > -1);

                    if (shouldAppend) {
                        if (href.indexOf("?") > -1) href += "&";else href += "?";

                        // if its seller.carsalesnetwork then we always want to return to the homepage of the hero site
                        if (currentUrl.indexOf('seller.carsalesnetwork') > -1) {
                            var heroSiteDomain = $(data).data("hero-site-domain");

                            if (heroSiteDomain.indexOf('http://') == -1) {
                                heroSiteDomain = 'http://' + heroSiteDomain;
                            }

                            href += "src=sitenav&ret=" + encodeURIComponent(heroSiteDomain);
                        } else {

                            href += "src=sitenav&ret=" + encodeURIComponent(currentUrl);
                        }

                        var tracking = $(data).data("tracking");
                        if (tracking && tracking.length > 0) {
                            href += "&" + tracking;
                        }

                        $(data).attr("href", href);
                    }
                });
            }
        };

        sitenav.App.ReturnUrlBuilder.appendReturnUrl();
    })(jQuery, window.sitenav);
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function ($) {
    var activeMenu = null,
        timer,
        MENU_TIMEOUT = 300,
        topLevelMenu = $(".site-nav-wrapper .site-nav > ul"),
        closeOpenDropDown = function closeOpenDropDown() {
        if ($.fn.multiPurposeSelect && $.fn.multiPurposeSelect.openMenu) {
            $.fn.multiPurposeSelect.openMenu.close();
        } else {
            $("select").blur();
        }
    },
        timeoutHandler = function timeoutHandler() {

        closeOpenDropDown();
        topLevelMenu.addClass("menu-active");
        clearTimeout(timer);
    };
    if (!navigator.userAgent.match(/iPad/i)) {
        topLevelMenu.children("li:not('.nav-notifications')").hover(function () {
            $(".nav-notifications  .menu-panel").removeClass("visible");timer = setTimeout(timeoutHandler, MENU_TIMEOUT);
        }, function () {
            clearTimeout(timer);topLevelMenu.removeClass("menu-active");
        });
    } else {
        topLevelMenu.children("li:not('.nav-notifications')").each(function (i) {
            var item = $(this);
            if (i > 0) {
                item.children("a").on("click", function (event) {
                    var menuChild = $(this).next(".menu-panel");
                    if (activeMenu && activeMenu[0] !== menuChild[0]) {
                        item.parent().removeClass("menu-active");
                        activeMenu = null;
                    }
                    if (!activeMenu) {
                        activeMenu = menuChild;
                        event.preventDefault();
                        item.parent().addClass("menu-active");
                    }
                });
                item.on("touchstart", function (event) {
                    event.stopPropagation();
                });
            }
        });
        topLevelMenu.children("li:not('.nav-notifications')").find("li a").on("touchstart", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            location.href = this.href;
        });
        $("body").on("touchstart", function (event) {
            if (activeMenu) {
                activeMenu.parent().removeClass("hover");activeMenu = null;
            }
        });
    }
})(jQuery);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {
    $("#footer-subscribe-newsletter-form").submit(function (e) {
        var self = this;
        e.preventDefault();

        var url = $(this).data('url');
        $.post(url, $("#footer-subscribe-newsletter-form").serialize()).success(function () {
            $(self).parent().addClass("success");
            $(self).parent().removeClass("fail");
        }).fail(function () {
            $(self).parent().addClass("fail");
        });
    });
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3);
__webpack_require__(7);
__webpack_require__(15);
__webpack_require__(16);
__webpack_require__(4);
__webpack_require__(5);
__webpack_require__(10);
__webpack_require__(6);

__webpack_require__(12);

__webpack_require__(0);
__webpack_require__(1);
__webpack_require__(2);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bikesales-v2-assets-05e74f684b69b20be0a3.js